<div class="sidenav-container">
    <app-sidenav-header [title]="displayName ? displayName : name" [subtitle]="(category === 'Optional' ? 'ADD_VERSION.OPTIONAL_CAPABILITIES' : 'ADD_VERSION.INCLUDED_CAPABILITIES') | transloco"> </app-sidenav-header>
    <span class="flex flex-row items-center badge fs-10 fw-700 pl-8 pr-8 ml-174 inline-flex">{{ componentType }}</span>
    <div class="content">
        <div>
            <span class="titledetails fs-14 fw-700">{{'ADD_VERSION.DISPLAY_NAME' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{displayName ? displayName : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'ADD_VERSION.NAME' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{name ? name : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'SOLUTIONS.DESCRIPTION' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{description ? description : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'SOLUTIONS.RELEASE_VERSION' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{releaseVersion ? releaseVersion : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'COMPONENTS.COMPONENT_TYPE' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{componentType ? componentType : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'SOLUTIONS.VERSION' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{version ? version : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'COMPONENTS.CREATED_ON' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{dateCreated ? (dateCreated | date: 'dd MMM yyyy, HH:mm') + ' UTC' : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'COMPONENTS.UPDATED_ON' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400">{{dateUpdated ? (dateUpdated | date: 'dd MMM yyyy, HH:mm') + ' UTC' : '-'}}</span>
        </div>
        <br />
        <div>
            <span class="titledetails fs-14 fw-700">{{'COMPONENTS.PARAMATER_SPECIFICATION' | transloco}}</span><br />
            <span class="valuedetails fs-16 fw-400" *ngIf="!parameterSpec">{{'-'}}</span>
            <a class="releasedetails fs-16 fw-400" *ngIf="parameterSpec" href="javascript:void(0)" (click)="onClick(parameterSpec)">{{'SOLUTIONS.VIEW' | transloco}}</a>
        </div>
    </div>
</div>
